// Dashboard API client — fetches stats from GET /dbam/v1/dashboard/stats
import { getKernelApiBase } from './cloudApi';

/**
 * Fetch dashboard statistics for an organization.
 * @param {string} orgId  — Organization ID (omit for all-org aggregate)
 * @returns {Promise<Object>} DashboardStats payload
 */
export async function fetchDashboardStats(orgId) {
    const base = getKernelApiBase().replace(/\/$/, '');
    let url = `${base}/dashboard/stats`;
    if (orgId) url += `?org_id=${encodeURIComponent(orgId)}`;

    const resp = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });

    if (!resp.ok) {
        const text = await resp.text().catch(() => '');
        throw new Error(`Dashboard stats failed (${resp.status}): ${text || resp.statusText}`);
    }

    const json = await resp.json();
    // sam-dbam wraps responses as { data: ..., meta: ... }
    return json.data !== undefined ? json.data : json;
}
